<template>
  <b-form-group
    :label="$t(label)"
    class="input-label"
    v-b-tooltip.hover.right
    :title="$t(tooltip)"
  >
    <b-form-input
      :id="id"
      @input="$emit('input', $event)"
      :value="int_value"
      :state="isValid"
      :readonly="readonly"
      trim
    ></b-form-input>
  </b-form-group>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    tooltip: {
      type: String,
    },
    min: {
      type: Number,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    formatter: {},
    value: {},
    id: {},
  },

  data() {
    return {
      int_value: null,
    };
  },

  watch: {
    value(val) {
      if (this.formatter) {
        this.int_value = this.formatter(val);
      } else {
        this.int_value = val;
      }
    },
  },

  computed: {
    isValid() {
      if (this.required) {
        let retorno = null;
        if (this.min != undefined && this.min != null) {
          retorno =
            (this.value != null && this.value.length) >= +this.min
              ? true
              : false;
        }
        return retorno;
      } else {
        return null;
      }
    },
  },
};
</script>
